import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";
import type { ComponentProps, ReactElement, ReactNode } from "react";

import { cn } from "../foundations/cn.js";
import { POPUP_MOTION } from "../foundations/interaction.js";

/** Shares one open delay across every tooltip below it: mount once near the app's root. */
export function TooltipProvider(props: ComponentProps<typeof BaseTooltip.Provider>) {
  return <BaseTooltip.Provider {...props} />;
}

export interface TooltipProps {
  /** The element it describes. It must already have a name of its own. */
  children: ReactElement;
  /** A few words of extra context; never the only place information lives. */
  content: ReactNode;
  side?: "top" | "bottom" | "left" | "right";
}

/** A few words about a control, shown on hover and keyboard focus. */
export function Tooltip({ children, content, side = "top" }: TooltipProps) {
  return (
    <BaseTooltip.Root>
      <BaseTooltip.Trigger render={children} />
      <BaseTooltip.Portal>
        <BaseTooltip.Positioner side={side} sideOffset={6} className="z-50">
          <BaseTooltip.Popup
            className={cn(
              "max-w-64 rounded-sm border border-border-default bg-bg-raised px-2.5 py-1.5 font-body text-body-b3 text-text-primary shadow-float",
              POPUP_MOTION,
            )}
          >
            {content}
          </BaseTooltip.Popup>
        </BaseTooltip.Positioner>
      </BaseTooltip.Portal>
    </BaseTooltip.Root>
  );
}
